import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { Heading } from '../../../components';
import { richText } from '../../../util/richText';

import css from './ListingPageSections.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

/**
 * About this equipment / trailer — listing description.
 *
 * @component
 */
const SectionAboutEquipment = props => {
  const { description, isTrailer, className, rootClassName } = props;

  if (!description) {
    return null;
  }

  const classes = classNames(rootClassName || css.aboutSection, className);
  const content = richText(description, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.aboutHeading}>
        <FormattedMessage
          id={isTrailer ? 'ListingPage.aboutTrailerTitle' : 'ListingPage.aboutEquipmentTitle'}
        />
      </Heading>
      <div className={css.aboutText}>{content}</div>
    </section>
  );
};

export default SectionAboutEquipment;
